// TODO: Move into an @hitiq/logger.datadog package.
import {
  datadogLogs,
  StatusType,
  Logger as dgLogger,
} from '@datadog/browser-logs';
import { Logger, LogType, Transport } from '@hitiq/logger';
import { injectable } from 'inversify';

@injectable()
export class DatadogLogger implements Logger {
  public logger: dgLogger;

  /**
   * @param name Storage locations for logs.
   * @param level The max log level to write out. Overridden by transport levels.
   */
  constructor(name: string, level: LogType) {
    let datadogLevel: StatusType = 'debug';
    switch (level) {
      case LogType.silly:
      case LogType.debug:
      case LogType.verbose:
        datadogLevel = 'debug';
        break;
      case LogType.info:
      case LogType.http:
        datadogLevel = 'info';
        break;
      case LogType.warn:
        datadogLevel = 'warn';
        break;
      case LogType.error:
        datadogLevel = 'error';
        break;
      default:
        break;
    }

    this.logger = datadogLogs.createLogger(name, { level: datadogLevel });
    this.logger.addContext('subService', name);
  }

  log(type: LogType, message: string): void {
    switch (type) {
      case LogType.silly:
      case LogType.debug:
      case LogType.verbose:
        this.logger.debug(message);
        break;
      case LogType.info:
      case LogType.http:
        this.logger.info(message);
        break;
      case LogType.warn:
        this.logger.warn(message);
        break;
      case LogType.error:
        this.logger.error(message);
        break;
      default:
        break;
    }
  }

  createLogger(level: LogType, transports: Transport[]): void {
    throw new Error('Not Implemented for Datadog');
  }

  addTransport(transport: Transport): void {
    throw new Error('Not Implemented for Datadog');
  }

  removeTransport(transport: Transport) {
    throw new Error('Not Implemented for Datadog');
  }
}
export {};
